import { render, staticRenderFns } from "./Deliveryupdated_date.vue?vue&type=template&id=aa09e75a"
import script from "./Deliveryupdated_date.vue?vue&type=script&lang=js"
export * from "./Deliveryupdated_date.vue?vue&type=script&lang=js"
import style0 from "./Deliveryupdated_date.vue?vue&type=style&index=0&id=aa09e75a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports